import AsyncSelect from "react-select/async";

const ReactSelect = ({ label, value, id, onClick, disabled, handleChange, placeholder, options, important, multiselect, searchable, defaultValue, defaultInputValue, onInputChange, cacheOptions = true }) => {
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "#5932EA" : "#80858C",
      background: state.isSelected ? "#F5F6FA" : "#fff",
      padding: 10,
    }),
    control: () => ({
      // none of react-select's styles are passed to <Control />
      width: "100%",
      maxWidth: "100%",
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";
      return { ...provided, opacity, transition };
    },
  };

  return (
    <>
      {label ? (
        <label>
          {label} {important ? <span className="text-danger">*</span> : <span></span>}
        </label>
      ) : (
        ""
      )}
      <AsyncSelect
        className="text-secondary  bg-white text-capitalize"
        classNamePrefix="react-select-container"
        defaultValue={defaultValue}
        defaultInputValue={defaultInputValue}
        isMulti={multiselect}
        isDisabled={disabled}
        isSearchable={searchable}
        loadOptions={options}
        closeMenuOnSelect={true}
        cacheOptions={cacheOptions}
        defaultOptions
        value={value}
        placeholder={placeholder}
        id={id}
        onClick={onClick}
        onChange={handleChange}
        styles={customStyles}
        onInputChange={onInputChange}
        isClearable={true}
      />
    </>
  );
};

export default ReactSelect;
